<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <router-link tag="button" :to="{name: 'administrators.create'}" class="btn btn-info">
          <span class="btn-label">
            <i class="material-icons">add</i>
          </span>
          Novo
        </router-link>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-icon card-header-rose">
            <div class="card-icon">
              <i class="material-icons">list</i>
            </div>
            <h4 class="card-title">Lista</h4>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th class="text-center">#</th>
                    <th>Nome</th>
                    <th>Logo</th>
                    <th class="text-right">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-show="items.length > 0" v-for="iterator in items" :key="iterator.id">
                    <td class="text-center">{{ iterator.id }}</td>
                    <td>{{ iterator.name }}</td>
                    <td>
                      <md-avatar class="md-large">
                        <img :src="apiBaseUrl + '/' + iterator.logo">
                      </md-avatar>
                    </td>
                    <td class="td-actions text-right">
                      <index-buttons
                        :iterator="iterator"
                        :showAudit="false"
                        :toAudit="{name: 'dashboard'}"
                        :showEdit="true"
                        :toEdit="{name: 'administrators.edit', params: { id: iterator.id }}"
                        :showRemove="true"
                        dispatchRemove="administrators/rem"
                        :callbackRemove="getData"
                      >
                        <router-link
                          data-original-title
                          title="Planos"
                          class="btn btn-info btn-link"
                          tag="button"
                          :to="{name: 'administrators.plans.index', params: { administrator_id: iterator.id }}"
                        >
                          <i class="material-icons">list</i>
                        </router-link>
                      </index-buttons>
                    </td>
                  </tr>
                  <tr v-show="items.length==0">
                    <td colspan="4">Nenhuma administradora encontrada!</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Service from "@/services/api.service.js";
export default {
  computed: {
    items: {
      set(_items) {
        this.$store.commit("administrators/setList", _items);
      },
      get() {
        return this.$store.state.administrators.itens;
      }
    }
  },
  created: function() {
    this.items = [];
    this.getData();
  },
  data() {
    return {
      currentPage: 1,
      apiBaseUrl: Service.getBaseUrl(),
    };
  },
  methods: {
    remove: function(_item) {
      var self = this;
      this.$dialog
        .confirm(
          'Deseja realmente remover a administradora "' + _item.name + '"?'
        )
        .then(function() {
          self.$root.$emit("onLoading");

          const response = self.$store.dispatch("administrators/rem", _item);

          response.then(function() {
            self.$root.$emit("onLoading");
            self.$notify.success("Administradora excluída com sucesso!");
            self.getData();
          });

          response.catch(function() {
            self.$root.$emit("onLoading");
            self.$notify.danger("Não foi possível excluir a administradora!");
          });
        });
    },
    async getData() {
      var self = this;

      self.$root.$emit("onLoading");
      const response = self.$store.dispatch("administrators/all");

      response.then(function() {
        self.$root.$emit("onLoading");
      });

      response.catch(function() {
        self.$root.$emit("onLoading");
      });
    },
    getImg(_logo) {
      return "data: " + _logo.contentType + ";base64," + _logo.content;
    }
  }
};
</script>